import type { Enemy } from '../entities/Enemy';
import type { AABB } from '../core/Collision';
import { Vector2 } from '../core/Vector2';
import { NOISE_RADIUS_SHOT, NOISE_DURATION_MS } from '@hamsters/game-config';

export interface NoiseEvent {
  id: string;
  source: 'SHOT' | 'TRAP' | 'QUEST' | 'BOSS';
  x: number;
  y: number;
  radius: number;
  createdAtTick: number;
  durationMs: number;
}

export class NoiseSystem {
  private events: NoiseEvent[] = [];
  private nextId = 0;

  createNoise(
    source: NoiseEvent['source'],
    x: number,
    y: number,
    tick: number,
    radius: number = NOISE_RADIUS_SHOT,
  ): NoiseEvent {
    const event: NoiseEvent = {
      id: `noise_${this.nextId++}`,
      source,
      x,
      y,
      radius,
      createdAtTick: tick,
      durationMs: NOISE_DURATION_MS,
    };
    this.events.push(event);
    return event;
  }

  update(tick: number, _dt: number, enemies: Enemy[], _walls: AABB[]): void {
    // Remove expired events
    this.events = this.events.filter((e) => {
      const age = (tick - e.createdAtTick) * 16.666;
      return age < e.durationMs;
    });

    // Check if enemies can hear
    for (const event of this.events) {
      for (const enemy of enemies) {
        if (!enemy.isAlive()) continue;

        const dx = enemy.position.x - event.x;
        const dy = enemy.position.y - event.y;
        const dist = Math.sqrt(dx * dx + dy * dy);

        if (dist < event.radius) {
          // TODO: Check wall occlusion
          enemy.onPlayerSpotted(new Vector2(event.x, event.y));
        }
      }
    }
  }

  clear(): void {
    this.events = [];
  }

  getActiveEvents(): NoiseEvent[] {
    return this.events;
  }
}
